import React from 'react';
import styled from "styled-components";
import {theme} from "../../../../../theme";

const ModeButton = styled.div<{ isSelected?: boolean }>`
  display: flex;
  align-items: center;
  height: 100%;
  margin-right: 30px;
  padding: 0 3px;
  border-bottom: ${({ isSelected }) =>
  isSelected ? `2px solid ${theme.colors.themePrimary}` : 'none'};
  font-size: 14px;
  font-weight: ${(props) => (props.isSelected ? 'bold' : 'normal')};
  color: #333333;
  cursor: pointer;

  :last-child {
    margin-right: 0;
  }
`;

interface IProps {
  handleClick: () => void;
  isSelected: boolean;
  title: string;
}

const TabSelectionButton = ({ handleClick, isSelected, title }: IProps) => {
  return (
    <ModeButton onClick={handleClick} isSelected={isSelected} >
      {title}
    </ModeButton>
  );
};

export default TabSelectionButton;